import { Icon, InputAdornment } from '@mui/material';
import { AddressValidationStatus } from '@models/customer';
import { Check, InfoCircle, Sync, ExclamationCircle } from '@assets/svgs';
import { Tooltip } from '@components/tooltip/Tooltip';

interface IInputValidation {
  loading: boolean;
  error: Error | null;
  status?: string;
  duplicated?: boolean;
  isStateValid?: boolean;
}

export const InputValidation = ({ loading, status, error, duplicated, isStateValid }: IInputValidation) => {
  const commonAdornmentProps = {
    position: 'end' as const,
    sx: { position: 'absolute', right: 8 },
  };

  if (loading) {
    return (
      <InputAdornment {...commonAdornmentProps}>
        <Icon sx={{ color: 'text.subdued' }}>
          <Sync />
        </Icon>
      </InputAdornment>
    );
  }

  if (error || duplicated || isStateValid === false) {
    const title =
      error?.message || duplicated
        ? 'Location addresses must be unique'
        : !isStateValid
          ? `This jurisdiction is not yet available. 
          Please delete or change the address.`
          : undefined;

    return (
      <InputAdornment {...commonAdornmentProps}>
        <Tooltip tooltipBgColor='common.white' tooltipTextColor='common.black' title={title} placement='bottom' arrow>
          <Icon sx={{ color: 'other.error' }}>
            <ExclamationCircle />
          </Icon>
        </Tooltip>
      </InputAdornment>
    );
  }

  if (!status) return null;

  const reviewMessage = 'Address could not be auto-approved and will be referred to the LIO team for review';

  const infoCircleTooltip = (
    <Tooltip title={reviewMessage} placement='bottom' arrow>
      <Icon sx={{ color: 'text.subdued' }}>
        <InfoCircle />
      </Icon>
    </Tooltip>
  );

  const validationIcon = {
    [AddressValidationStatus.ExactMatch]: (
      <Icon sx={{ ' svg': { color: 'other.success' } }}>
        <Check />
      </Icon>
    ),
    [AddressValidationStatus.PartialMatch]: infoCircleTooltip,
    [AddressValidationStatus.NoMatch]: infoCircleTooltip,
    [AddressValidationStatus.MultipleMatch]: infoCircleTooltip,
  };

  return (
    <InputAdornment {...commonAdornmentProps}>{validationIcon[status as keyof typeof validationIcon]}</InputAdornment>
  );
};
